import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import RegisterPage from './pages/auth/RegisterPage';
import Dashboard from './pages/dashboard/Dashboard'; // Unified dashboard
import QRScanPage from './pages/qrscan/QRScanPage';
import NotFound from './pages/NotFound';
import AuthRedirector from './components/common/AuthRedirector';
import ProtectedRoute from './components/common/ProtectedRoute';

// Import all page components needed for nested routes
// Mahasiswa
import MahasiswaDashboardHome from './pages/mahasiswa/MahasiswaDashboardHome'; // Assuming this exists or create a generic one
import KatalogInstrumen from './pages/mahasiswa/KatalogInstrumen';
import KatalogAlatGelas from './pages/mahasiswa/KatalogAlatGelas';
import KatalogBahan from './pages/mahasiswa/KatalogBahan';
import JadwalPenggunaan from './pages/mahasiswa/JadwalPenggunaan'; // Assuming one jadwal page for now
import FormPeminjamanAlat from './pages/mahasiswa/FormPeminjamanAlat';
import FormPermintaanBahan from './pages/mahasiswa/FormPermintaanBahan';
import StatusPermintaan from './pages/mahasiswa/StatusPermintaan';
import AlatSiapDigunakan from './pages/mahasiswa/AlatSiapDigunakan';
import IsiLogbookInstrumen from './pages/mahasiswa/IsiLogbookInstrumen'; // Needed if linked directly
import EditProfileMahasiswa from './pages/mahasiswa/EditProfileMahasiswa';

// Dosen
import PersetujuanPengajuanDosen from './pages/dosen/PersetujuanPengajuanDosen';
import RiwayatPengajuanDosen from './pages/dosen/RiwayatPengajuanDosen';
// import EditProfileDosen from './pages/dosen/EditProfileDosen'; // If exists

// Laboran
import PersetujuanPermintaanAlatLaboran from './pages/laboran/PersetujuanPermintaanAlat'; // Corrected import name
import PersetujuanPermintaanBahanLaboran from './pages/laboran/PersetujuanPermintaanBahan';
import MonitoringAlat from './pages/laboran/MonitoringAlat';
import MonitoringBahan from './pages/laboran/MonitoringBahan';
import JadwalPenggunaanLaboran from './pages/laboran/JadwalPenggunaan'; // Assuming specific laboran view
import LogbookLaboran from './pages/laboran/Logbook'; // Assuming specific laboran view
// import EditProfileLaboran from './pages/laboran/EditProfileLaboran'; // If exists

// Admin
import AdminDashboardHome from './pages/admin/AdminDashboardHome';
import ManajemenPengguna from './pages/admin/ManajemenPengguna';
import ApproveUsers from './pages/admin/ApproveUsers';
import ManajemenInstrumen from './pages/admin/ManajemenInstrumen';
import ManajemenAlatGelas from './pages/admin/ManajemenAlatGelas';
import ManajemenBahan from './pages/admin/ManajemenBahan';
import PersetujuanPermintaanAlatAdmin from './pages/admin/PersetujuanPermintaanAlat'; // Corrected import name
import PersetujuanPermintaanBahanAdmin from './pages/admin/PersetujuanPermintaanBahan';
import LaporanLogbook from './pages/admin/LaporanLogbook';
import LaporanPenggunaanAlat from './pages/admin/LaporanPenggunaanAlat';
import LaporanPenggunaanBahan from './pages/admin/LaporanPenggunaanBahan';
import LaporanKerusakan from './pages/admin/LaporanKerusakan';
import AdminIsiLogbook from './pages/admin/AdminIsiLogbook';
// import EditProfileAdmin from './pages/admin/EditProfileAdmin'; // If exists

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/" element={<AuthRedirector />} />

        {/* Unified Dashboard Route */}
        {/* Unified Dashboard Route with Nested Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard /> {/* The layout component */}
            </ProtectedRoute>
          }
        >
          {/* Index route for the dashboard homepage - handled by RoleBasedDashboardHome in Dashboard.js */}
          <Route index element={null} /> {/* Content handled by RoleBasedDashboardHome wrapper */}

          {/* Mahasiswa Routes */}
          <Route path="katalog-instrumen" element={<KatalogInstrumen />} />
          <Route path="katalog-alat-gelas" element={<KatalogAlatGelas />} />
          <Route path="katalog-bahan" element={<KatalogBahan />} />
          <Route path="jadwal-penggunaan" element={<JadwalPenggunaan />} />
          <Route path="form-peminjaman-alat" element={<FormPeminjamanAlat />} />
          <Route path="form-permintaan-bahan" element={<FormPermintaanBahan />} />
          <Route path="status-permintaan" element={<StatusPermintaan />} />
          <Route path="alat-siap-digunakan" element={<AlatSiapDigunakan />} />
          <Route path="isi-logbook" element={<IsiLogbookInstrumen />} /> {/* If directly accessible */}
          <Route path="edit-profil" element={<EditProfileMahasiswa />} />

          {/* Dosen Routes */}
          <Route path="persetujuan-pengajuan" element={<PersetujuanPengajuanDosen />} />
          <Route path="riwayat-pengajuan" element={<RiwayatPengajuanDosen />} />
          {/* <Route path="edit-profil-dosen" element={<EditProfileDosen />} /> */}

          {/* Laboran Routes */}
          <Route path="persetujuan-alat-laboran" element={<PersetujuanPermintaanAlatLaboran />} />
          <Route path="persetujuan-bahan-laboran" element={<PersetujuanPermintaanBahanLaboran />} />
          <Route path="monitoring-alat" element={<MonitoringAlat />} />
          <Route path="monitoring-bahan" element={<MonitoringBahan />} />
          <Route path="jadwal-penggunaan-laboran" element={<JadwalPenggunaanLaboran />} />
          <Route path="logbook-laboran" element={<LogbookLaboran />} />
          {/* <Route path="edit-profil-laboran" element={<EditProfileLaboran />} /> */}

          {/* Admin Routes */}
          <Route path="manajemen-pengguna" element={<ManajemenPengguna />} />
          <Route path="approve-users" element={<ApproveUsers />} />
          <Route path="manajemen-instrumen" element={<ManajemenInstrumen />} />
          <Route path="manajemen-alat-gelas" element={<ManajemenAlatGelas />} />
          <Route path="manajemen-bahan" element={<ManajemenBahan />} />
          <Route path="persetujuan-alat-admin" element={<PersetujuanPermintaanAlatAdmin />} />
          <Route path="persetujuan-bahan-admin" element={<PersetujuanPermintaanBahanAdmin />} />
          <Route path="laporan-logbook" element={<LaporanLogbook />} />
          <Route path="laporan-penggunaan-alat" element={<LaporanPenggunaanAlat />} />
          <Route path="laporan-penggunaan-bahan" element={<LaporanPenggunaanBahan />} />
          <Route path="laporan-kerusakan" element={<LaporanKerusakan />} />
          <Route path="admin-isi-logbook" element={<AdminIsiLogbook />} />
          {/* <Route path="edit-profil-admin" element={<EditProfileAdmin />} /> */}

          {/* Add a fallback within dashboard if needed, or let the main fallback handle it */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Route>

        {/* Centralized Scan Route */}
        <Route
          path="/scan-alat"
          element={
            <ProtectedRoute>
              <QRScanPage />
            </ProtectedRoute>
          }
        />

        {/* Add other protected routes here as needed, e.g., specific pages */}
        {/* Example:
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          }
        />
        */}

        {/* Fallback Route - Make sure this is the last route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
